var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flex-element',{attrs:{"element-type":_vm.elementType,"tag":"li"}},[_c('a-link',_vm._b({on:{"element-updated":_vm.elementUpdated}},'a-link',_vm.element(1),false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }